export const emptyResourceSummary = {
    raster: 0,
    vector: 0,
    application: 0,
    table: 0,
    scenario: 0,
    notebook: 0,
};
